/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// Components
import BadgeLayout from 'shared/ui/components/editors/design/BadgeLayout.vue';

// Constants
const COMPONENT_MODES = {
    'badge_design': BadgeLayout,
    'certificate_design': BadgeLayout
};

const __vue_script__ = {
    name: 'CreativeEditor',

    props: {
        event: {
            type: Object,
            required: true
        },

        user: {
            type: Object,
            required: true
        },

        config: {
            type: Object,
            default: () => ({
                mode: 'standalone'
            })
        }
    },

    data() {
        return {
            extForm: COMPONENT_MODES[this.config.modelFpType] || null,
            model: {},
            saveSpy: 0,
        };
    },

    async mounted() {
        await this.init();
    },

    methods: {
        async init() {
            await this.loadDesign();
        },

        async loadDesign() {
            try {
                const { eventId, modelId } = this.$router.getRouteParams() || {};
                if (modelId) {
                    this.model = await this.$services.documents.getDocById(eventId, modelId);
                }
            } catch (error) {
                console.error('[CreativeEditor] Could not load model', error);
            }
        },

        async save(formData) {
            try {
                console.info('[CreativeEditor] Saving design', formData);

                const { _id: eventId } = this.event;
                const node = this.$utils.workspaces.getRootNodeName(this.event);
                const fpType = this.config.modelFpType;
                const doc = formData;

                const { data } = await this.$services.documents.updateDoc(eventId, node, fpType, doc);
                const [modelId] = data.upsertedDocIds;

                console.info('[CreativeEditor] Successfully saved', doc, data);

                if (!formData._id) {
                    // If it's a new design, redirect the user to the proper detailed page after saving
                    let path;
                    if (fpType === 'badge_design') {
                        const { route } = this.$services.blueprint.getControllerByName('badge-design', 'view');
                        path = route[0]
                            .replace(':eventId', eventId)
                            .replace(':modelId', modelId);
                    }
                    this.$services.router.redirect(path);
                } else {
                    // ...if it's an existing design, reload the model after save
                    // so that the WYSIWYG between UI and BE data is honored
                    await this.init();
                }
            } catch (error) {
                console.error('[CreativeEditor] Could not save layout', error);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"creative-editor"},[_c(_vm.extForm,{tag:"component",attrs:{"event":_vm.event,"user":_vm.user,"config":_vm.config,"save-spy":_vm.saveSpy},on:{"save":_vm.save},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}),_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.saveSpy = Date.now()}}},[_vm._v(_vm._s(_vm.$t('general.save')))])])],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "CreativeEditor.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__